import React, { useEffect, useState } from "react";
import { useParams, useNavigate } from "react-router-dom";
import { motion } from "framer-motion";
import { blogs } from "../Blog";
import Breadcrumb from "../Components/Breadcrumb";
import { FiUser } from "react-icons/fi";
import { FaSearch } from "react-icons/fa";
import ErrorPage from "./ErrorPage";
import Cta from "../Components/Cta";
import SchemaMarkup from "../Components/SchemaMarkup";
import WebPageSchema from "../Schema/WebpageSchema";
import BlogPostingSchema from "../Schema/BlogPostingSchema";
import BreadcrumbSchema from "../Schema/BreadcrumbSchema";
import OtherBlogs from "../Components/OtherBlogs";
/*import OtherBlogs from "../Components/OtherBlogs";*/

const BlogDetail=()=>{
const { slug } = useParams();
  const navigate = useNavigate();

const [searchTerm, setSearchTerm] = useState("");

  const blog = blogs.find(item => item.slug === slug);

  const safeBlogs = Array.isArray(blogs) ? blogs : [];

const categoriesList = [];

safeBlogs.forEach((item) => {
  if (
    item &&
    item.category &&
    !categoriesList.includes(item.category)
  ) {
    categoriesList.push(item.category);
  }
});

const suggestions = [];

const cleanTerm = searchTerm.trim().toLowerCase();

if (cleanTerm !== "") {

  categoriesList.forEach((cat) => {
    if (cat.toLowerCase().includes(cleanTerm)) {
      suggestions.push({
        type: "category",
        value: cat,
      });
    }
  });

  safeBlogs.forEach((item) => {
    if (
      item &&
      item.title &&
      item.title.toLowerCase().includes(cleanTerm)
    ) {
      suggestions.push({
        type: "blog",
        value: item.title,
        slug: item.slug,
      });
    }
  });

}

const handleSearchSubmit = () => {

  if (suggestions.length > 0) {

    const topResult = suggestions[0];

    if (topResult.type === "category") {

      navigate("/blog#blog-grid", {
        state: {
          selectCategory: topResult.value,
        },
      });

    } else {

      navigate(`/blog/${topResult.slug}`);
      setSearchTerm("");

    }

  } else if (searchTerm.trim() !== "") {

    navigate("/blog#blog-grid", {
      state: {
        searchString: searchTerm,
      },
    });

  }

};

const handleKeyDown = (e) => {
  if (e.key === "Enter") {
    handleSearchSubmit();
  }
};

const handleCategoryClick = (categoryName) => {

  navigate("/blog#blog-grid", {
    state: {
      selectCategory: categoryName,
    },
  });

};

useEffect(() => {
    if (!blog) return;
    document.title = `${blog.metaTitle}`;

    const metaDesc = document.querySelector("meta[name='description']");
    if (metaDesc) {
      metaDesc.setAttribute("content", blog.metaDesc);
    }


        let canonical = document.querySelector("link[rel='canonical']");
  if (!canonical) {
    canonical = document.createElement("link");
    canonical.setAttribute("rel", "canonical");
    document.head.appendChild(canonical);
  }

  canonical.setAttribute(
    "href",
    `https://onbbits.io/blog/${slug}`
  );

    const ogTitle = document.querySelector("meta[property='og:title']");
    if (ogTitle) {
      ogTitle.setAttribute("content", blog.metaTitle);
    }

    const ogDesc = document.querySelector("meta[property='og:description']");
    if (ogDesc) {
      ogDesc.setAttribute("content", blog.metaDesc);
    }


  const ogUrl = document.querySelector("meta[property='og:url']");
  if (ogUrl) {
    ogUrl.setAttribute("content",  `https://onbbits.io/blog/${slug}`);
  }

const ogImage = document.querySelector("meta[property='og:image']");
if (ogImage && blog?.image) {
  ogImage.setAttribute(
    "content",
    blog.img.startsWith("http")
      ? blog.img
      : `https://onbbits.io/${blog.img}`
  );
}

    const twitterTitle = document.querySelector("meta[name='twitter:title']");
    if (twitterTitle) {
      twitterTitle.setAttribute("content", blog.metaTitle);
    }

    const twitterDesc = document.querySelector("meta[name='twitter:description']");
    if (twitterDesc) {
      twitterDesc.setAttribute("content", blog.metaDesc);
    }

    const twitterImage = document.querySelector(
  "meta[name='twitter:image']"
);

if (twitterImage) {
  twitterImage.setAttribute(
    "content",
    window.location.origin + blog.img
  );
}
  }, [blog, slug]);

  if (!blog) {
    return <ErrorPage />;
  }

const blogUrl = `https://onbbits.io/blog/${blog.slug}`;


const fadeUp = {
  hidden: {
    opacity: 0,
    y: 40,
  },
  visible: {
    opacity: 1,
    y: 0,
    transition: {
      duration: 0.7,
    },
  },
};

const buttonAnim = {
  hidden: {
    opacity: 0,
    scale: 0.9,
  },
  visible: {
    opacity: 1,
    scale: 1,
    transition: {
      delay: 0.4,
      duration: 0.5,
    },
  },
};

    return(
        <>

<SchemaMarkup
  data={WebPageSchema({
    type: "WebPage",
    name: blog.title,
    description: blog.metaDesc || blog.introDesc,
    url: blogUrl
  })}
/>

<SchemaMarkup
  data={BlogPostingSchema({
    headline: blog.title,
    description: blog.metaDesc || blog.introDesc,
    url: blogUrl,
    image: blog.img?.startsWith("http")
      ? blog.img
      : `https://onbbits.io/${blog.img}`,
    datePublished: blog.date,
    authorName: "ONBBITS"
  })}
/>

<SchemaMarkup
  data={BreadcrumbSchema({
    items: [
      {
        name: "Home",
        url: "https://onbbits.io/"
      },
      {
        name: "Blog",
        url: "https://onbbits.io/blog"
      },
      {
        name: blog.title,
        url: blogUrl
      }
    ]
  })}
/>
                 {/**BREADCRUMB */}
        <Breadcrumb title={blog.title} />

    {/**BLOG CONTENT + SIDEBAR */}
        <section className="blog-detail-section">
  <div className="container">

    <div className="blog-detail-layout">

      {/* LEFT */}
      <div className="blog-detail-main">

        <h2 className="section-heading">
          {blog.title}
        </h2>

        <p className="section-text blog-intro-desc">
          {blog.introDesc}
        </p>

        <img
          src={blog.img}
          alt={`${blog.title} | Onbbits`}
          className="blog-detail-image"
        />

        <div
          className="blog-detail-content"
          dangerouslySetInnerHTML={{
            __html: blog.content,
          }}
        />

      </div>

      {/* RIGHT SIDEBAR */}
      <aside className="blog-detail-sidebar">
          <div className="blog-meta-box">

      <div className="blog-meta-icon">
        <FiUser />
      </div>

      <div className="blog-meta-content">

        <h3 className="card-heading">
          Admin
        </h3>

        <p className="blog-date section-text">
          Posted On : {blog.date}
        </p>

      </div>

    </div>

            <motion.div
                className="blog-sidebar-box"
                variants={fadeUp}
              >
      
               <div className="blog-search">

  <input
    type="text"
    placeholder="Search Category / Articles"
    value={searchTerm}
    onChange={(e) => setSearchTerm(e.target.value)}
    onKeyDown={handleKeyDown}
  />

  {suggestions.length > 0 && (
    <div className="blog-search-dropdown">

      {suggestions.map((item, idx) => (

        <div
          key={idx}
          className="blog-search-item"
          onClick={() => {

            if (item.type === "category") {

              handleCategoryClick(item.value);

            } else {

              navigate(`/blog/${item.slug}`);
              setSearchTerm("");

            }

          }}
        >

          <span>
            {item.type === "category"
              ? "Category"
              : "Blog"}
          </span>

          {item.value}

        </div>

      ))}

    </div>
  )}

  <div
    onClick={handleSearchSubmit}
    style={{ cursor: "pointer" }}
  >
    <FaSearch className="blog-search-icon" />
  </div>

</div>
      
                <h3 className="card-heading">
                  Categories
                </h3>
      
                <ul className="blog-categories">
      
                  {categoriesList.map((item, i) => (
                  <button
                      key={i}
                      initial={{
                        opacity: 0,
                        x: 20,
                      }}
                      whileInView={{
                        opacity: 1,
                        x: 0,
                      }}
                      viewport={{
                        once: true,
                      }}
                      transition={{
                        delay: i * 0.08,
                        duration: 0.4,
                      }}
                    >
                     <span
  onClick={() => handleCategoryClick(item)}
  style={{
    cursor: "pointer",
    display: "block",
  }}
>
  {item}
</span>
                    </button>
                  ))}
      
                </ul>
      
              </motion.div>

       <motion.div
                 className="blog-sidebar-cta"
                 initial={{
                   opacity: 0,
                   y: 50,
                 }}
                 whileInView={{
                   opacity: 1,
                   y: 0,
                 }}
                 viewport={{
                   once: true,
                 }}
                 transition={{
                   duration: 0.8,
                 }}
               >
       
                <h3 className="card-heading">
                            Ready to Automate Your WhatsApp Communication?
                          </h3>
                
                          <p className="section-text">
                          Automate repetitive messages, manage leads, and streamline customer communication with powerful WhatsApp automation solutions built for business growth.
                          </p>
                
                          <ul className="section-text">
                            <li>✓ Automated WhatsApp Messages & Replies</li>
                            <li>✓ Smart Lead Follow-Ups & Engagement</li>
                            <li>✓ Save Time & Grow Your Business Faster</li>
                          </ul>
                
                          <motion.a
                            href="https://app.onbbits.io/register"
                            target="_blank"
                            rel="noreferrer"
                            className="btn btn-primary"
                            variants={buttonAnim}
                            initial="hidden"
                            whileInView="visible"
                            viewport={{ once: true }}
                            whileHover={{
                              scale: 1.05,
                              y: -2,
                            }}
                            whileTap={{
                              scale: 0.97,
                            }}
                          >
                            Get Started for Free
                          </motion.a>
                
               </motion.div>
      </aside>

    </div>

  </div>
</section>

{/**OTHER BLOGS */}
<OtherBlogs
  currentSlug={blog.slug}
  isBlogDetail={true}
/>

{/**CTA */}
<Cta />
        </>
    )
}
export default BlogDetail;